import { DOCK_NAV, HAUPT_NAV, type HauptNavId } from '../../../lib/immobilien/sidebarNav';
import { ThemeIconKnopf } from '../ui/ThemeUmschalter';
import { HAUPT_ICONS } from './ListenModus';

/** Icon-Leiste unten im Objekt-, Mieter- und Eigentümermodus: Hell/Dunkel + App-Bereiche (README §5.6). */
export function SidebarDock({ aktiv, onNavigate }: { aktiv: HauptNavId; onNavigate: (pfad: string) => void }) {
  return (
    <div className="flex justify-between" style={{ padding: 6, borderRadius: 16, background: 'var(--fill)' }}>
      <ThemeIconKnopf />
      {/* aktiver Bereich ohne festen Platz (z. B. Eigentümer) ersetzt „Rechnungen“ */}
      {(DOCK_NAV.includes(aktiv) ? DOCK_NAV : DOCK_NAV.map(id => (id === 'rechnungen' ? aktiv : id))).map(id => {
        const eintrag = HAUPT_NAV.find(n => n.id === id);
        if (!eintrag) return null;
        const IconKomp = HAUPT_ICONS[id];
        const an = id === aktiv;
        return (
          <button
            key={id}
            type="button"
            title={eintrag.label}
            aria-label={eintrag.label}
            onClick={() => onNavigate(eintrag.path)}
            className="immo-hover-flaeche flex items-center justify-center cursor-pointer"
            style={{ width: 32, height: 32, borderRadius: 10, border: 'none', background: an ? 'var(--acc-soft)' : 'transparent' }}
          >
            <IconKomp weight={an ? 'fill' : 'regular'} size={17} color={an ? 'var(--acc)' : 'var(--ink2)'} />
          </button>
        );
      })}
    </div>
  );
}
